import { DebugEvent } from 'core/DebugEvent';
import { HTMLLoader } from 'core/loaders/HTMLLoader';

interface AjaxHTMLLoadedEventInterface {
	loader: HTMLLoader;
}

export class AjaxHTMLLoadedEvent extends DebugEvent implements AjaxHTMLLoadedEventInterface {
	public static eventName: string = 'AJAX_HTML_LOADED_EVENT';
	public loader: HTMLLoader;

	constructor(parameters: AjaxHTMLLoadedEventInterface) {
		super(parameters);
	}
}
